export default defineNuxtPlugin(() => {
  const { configOptimizelyWebExperiments } = useFeatureFlags()
  const { optimizelySnippetId } = useRuntimeConfig().public
  const route = useRoute()

  if (isOptimizelyWebDisabled(route.query.disableOptimizely)) return

  if (configOptimizelyWebExperiments.enabled && optimizelySnippetId) {
    const snippetUrl = `https://cdn.optimizely.com/js/${optimizelySnippetId}.js`

    useHead({
      link: [
        { href: snippetUrl, rel: 'preload', as: 'script', tagPriority: 20 },
        { href: 'https://logx.optimizely.com', rel: 'preconnect', tagPriority: 'high' }
      ],
      script: [
        {
          id: 'optimizely-snippet',
          src: snippetUrl,
          tagPriority: 20,
          fetchpriority: 'high',
          async: configOptimizelyWebExperiments.async,
          defer: false,
          onerror: (err) => {
            console.warn('failed to load Optimzely snippet', err)
          }
        }
      ]
    })
    if (isClient()) {
      window.optimizely = window.optimizely || []
      window.optimizely.push({
        type: 'activate'
      })
    }
  }
})
